export enum HotspotVideoBehaviourEnum {
  LAST_FRAME = 'last_frame',
  LOOP = 'loop'
}
